module.exports = __webpack_public_path__ + "static/media/20.f0481f34.png";